import { store } from "../../store";

export default class CommonUtil {
  static getTeamChecks = (checks, closedCheck = false) => {
    const checksList = checks && Array.from(checks.values());
    const state = store.getState();
    const { serverAppLogin, storeInfo, getStoreJobs } = state;
    const { jobs } = storeInfo.data;
    const allChecks = checksList.map(check => ({ ...check }));
    console.info('allChecks count', allChecks.length);
    let empChecks = [];
    const loginId = !!serverAppLogin.data && serverAppLogin.data.id;
    const storeJobs = getStoreJobs.data ? Object.values(getStoreJobs.data) : [];
    const job = jobs.find(j => j.id === (serverAppLogin.data && serverAppLogin.data.jobId));
    if (job) {
      const { checkVisibility } = job;
      if (checkVisibility === 2) {
        empChecks = allChecks;
      } else if (checkVisibility === 1) {
        try {
          empChecks = allChecks.filter(check => {
            const empJob = storeJobs.find(sj => sj.employeeId === check.employeeId);
            const empJobType = jobs.find(j => empJob && j.id === empJob.jobId);
            if (empJobType) return empJobType.jobTypeId === job.jobTypeId;
            return false;
          });
        } catch (error) {
          empChecks = [];
        }
      } else if (checkVisibility === 0) {
        empChecks = allChecks.filter(check => check.employeeId === loginId);
      }
    } else {
      empChecks = allChecks.filter(check => check.employeeId === loginId);
    }
    console.info('empChecks count', empChecks.length);
    if (!closedCheck)
      empChecks = empChecks.filter(check => check.open).sort(CommonUtil.sortFunction);
    if (empChecks.length > 0) {
      return empChecks;
    }
    return [];
  };

  static sortFunction = (a, b) => {
    if (!(a.stationName && b.stationName)) {
      return 0;
    }
    if (!isNaN(a.stationName) && !isNaN(b.stationName)) {
      return a.stationName - b.stationName;
    }
    const tab1 = a.stationName?.toLowerCase();
    const tab2 = b.stationName?.toLowerCase();
    if (tab1 < tab2) {
      return -1;
    }
    if (tab1 > tab2) {
      return 1;
    }
    return 0;
  };

}